// extracted by mini-css-extract-plugin
export default {"merchant_configurator_container":"MerchantConfigurator-module_merchant_configurator_container___BwLu","loading_container":"MerchantConfigurator-module_loading_container__bFKEU"};